<template>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <!-- <ion-title>Additional Information</ion-title> -->
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>Experience Edit</h1>
                </div>
                <div class="brand-icon">
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
                </div>
            </div> 
            <el-form class="full_page" :model="form" ref="userForm" label-position="top">    
                <el-form-item :error="v$.year_experience_id.$error" :show-message="false" class="no-scroll"
                    :required="true" prop="level">
                    <div class="item-select__header">
                        <div class="item-select__title">Experience</div>
                    </div>
                    <el-radio-group data-testid="directions-114" v-model="form.year_experience_id"
                        @change="validateField('year_experience_id')">
                        <el-radio v-for="level in getExperiences" :key="level.id" :label="level.id">{{
                            level.yearExperience
                        }}</el-radio>
                    </el-radio-group>
                    <el-form-item-error v-if="v$.year_experience_id.$error">{{ v$.year_experience_id.$errors[0].$message
                        }}</el-form-item-error>
                </el-form-item>
                <el-form-item :error="v$.category_level_ids.$error" :show-message="false" class="no-scroll"
                    :required="true" prop="category_level_ids">
                    <div class="item-select__header">
                        <div class="item-select__title">Role</div>
                    </div>
                    <el-checkbox-group data-testid="directions-104" v-model="form.category_level_ids"
                        @change="handleCheckboxRoleChange">
                        <el-checkbox v-for="level in getSeekerCategories" :key="level.id" :label="level.id">{{
                            level.title
                        }}</el-checkbox>

                    </el-checkbox-group>
                    <el-form-item-error v-if="v$.category_level_ids.$error">{{ v$.category_level_ids.$errors[0].$message
                        }}</el-form-item-error>
                </el-form-item>
                <div v-if="showOtherInput">
                    <el-input v-model="form.category_level_other" placeholder="Please specify other role"
                        @input="validateField('category_level_other')" @blur="validateField('category_level_other')" />
                    <el-form-item-error v-if="v$.category_level_other.$error">{{
                        v$.category_level_other.$errors[0].$message
                    }}</el-form-item-error>
                </div>
              
                <!-- Button to submit the form -->
                <el-form-item class="button_submit mb0">
                    <el-button class="submit btn-primary" type="primary" data-testid="directions-126"
                        :disabled="isSubmitDisabled" @click="handleSubmit">
                        Save
                    </el-button>
                </el-form-item>
            </el-form>
            <div class="background-circles">
                <div class="circle circle-2"></div>
                <div class="circle circle-1"></div>
                <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none"/>
            </div>
        </div>
    </div>
</template>

<script>
import { reactive, computed, inject, onMounted, ref, onBeforeMount, watch } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { required, helpers, requiredIf } from '@vuelidate/validators';

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
    "arrow-back-outline": arrowBackOutline,
});
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";
import SvgIcon from '@/components/Svg/SvgIcon.vue'; 

import { useStore } from "vuex";

import {
    useRouter,
    // useRoute
} from "vue-router";

export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        SvgIcon
    },
    directives: {},
    setup() {
        const $store = useStore();
        const $router = useRouter();
        // const $route = useRoute()
        const setPageClassGlobal = inject("setPageClassGlobal");
        const user = $store.getters.GET_USER_DATA;
        const backPage = $store.getters.getLastPage;
        let getExperiences = ref([]);
        let getSeekerCategories = ref([]);

        const form = reactive({
            category_level_other: user.settings?.categoryLevelOther ? user.settings?.categoryLevelOther : '',
            year_experience_id: user.settings?.yearExperienceId ? user.settings?.yearExperienceId : '',
            category_level_ids: user.settings?.categoryLevelIds ? user.settings?.categoryLevelIds : [],
        });

        const pageText = {
            pageTitle: 'Your profile',
            formText: 'what are your salary expectations?',
        };

        const rules = computed(() => {
            return {
                category_level_other: {
                    requiredIf: requiredIf(() => form.category_level_ids.includes(otherCategoryId.value)),
                    // Add custom message for the requiredIf validation
                    required: helpers.withMessage(
                        'Please enter the category level for "Other"',
                        requiredIf(() => form.category_level_ids.includes(otherCategoryId.value))
                    ),
                },
                year_experience_id: { required: helpers.withMessage('Please select the experience', required) },
                category_level_ids: { required: helpers.withMessage('Please enter the role', required) },
            };
        });

        const v$ = useVuelidate(rules, form);

        const isSubmitDisabled = computed(() => {
            // Check if "Other" is selected
            const isOtherSelected = form.category_level_ids.includes(otherCategoryId.value);

            return Object.values(form).some((value) => {
                // Ignore category_level_other if "Other" is not selected
                if (!isOtherSelected && value === form.category_level_other) {
                    return false; // Ignore this check for category_level_other
                }
                return value === ''; // Check for other empty values
            }) || v$.value.$pending || v$.value.$error || v$.value.$invalid;
        });

        const validateField = (fieldName) => {
            // Trigger validation for the specified field
            v$.value[fieldName].$touch();
        };

        const handleSubmit = async () => {
            const result = await v$.value.$validate();
            console.log("🚀 ~ handleSubmit ~ result:", form)
            if (!result) {
                v$.$touch();
            } (async () => {
                try {
                    await $store.dispatch("SAVE_USER_DATA", form);
                    goNext();
                } catch (error) {
                    console.log("error submit!!");
                }
            })();
        };

        const goBack = () => {
            $router.push({
                    name: "profile_edit",
                });

        };

        const goNext = () => {
            $router.push({
                    name: "profile_edit",
                });

        };

        onMounted(() => {
            setPageClassGlobal("global_job_seeker_additional_edit_page");
        });

        onBeforeMount(async () => {
            return new Promise((resolve) => {
                $store
                    .dispatch("GET_JOB_SEEKER_EXPERIENCE")
                    .then((response) => {
                        let FetchResult = response.data.experiences;
                        getExperiences.value = FetchResult;
                        resolve(response);
                    });
                $store
                    .dispatch("GET_JOB_SEEKER_CATEGORY")
                    .then((response) => {
                        let FetchResult = response.data.categories;
                        getSeekerCategories.value = FetchResult;
                        console.log("🚀 ~ onBeforeMount ~ FetchResultdddd", FetchResult)
                        resolve(response);
                    });
            });
        });

        // Find the ID of the "Other" option dynamically
        const otherCategoryId = computed(() => {
            const otherOption = getSeekerCategories.value.find(
                (option) => option.title === "Other"
            );
            return otherOption ? otherOption.id : null;
        });

        const showOtherInput = computed(() =>
            form.category_level_ids.includes(otherCategoryId.value)
        );

        watch(
            () => form.category_level_ids,
            (newVal) => {
                if (newVal.includes(otherCategoryId.value)) {
                    validateField('category_level_other');
                }
            }
        );

        const handleCheckboxRoleChange = (value) => {
            // Check if 'Other' was unselected
            if (!value.includes(otherCategoryId.value)) {
                form.category_level_other = null; // Reset the category_level_other field

            }
        };

        return {
            user,
            // environment,
            goBack,
            handleSubmit,
            // checkValue,
            validateField,
            isSubmitDisabled,
            pageText,
            form,
            rules,
            v$,
            getExperiences,
            getSeekerCategories,
            backPage,
            showOtherInput,
            handleCheckboxRoleChange
        };
    },
};
</script>
<style scoped>
.button-wrapper {
    display: flex;
    margin-bottom: 10px;
}

.button-wrapper .el-button {
    margin-right: 10px;
}

.input-wrapper {
    display: flex;
    align-items: center;
}

.input-wrapper .el-input__prefix {
    margin-right: 5px;
}
</style>